import React, { FC } from 'react';
import * as classes from './SocialIcons.module.scss';
import { TemplatesList } from '../../../enums/TemplatesList';
import { ISocialNetwork } from '../../../interfaces/professional/Professional';
import SocialIcon from './SocialIcon/SocialIcon';

interface Props {
  template?: TemplatesList;
  items: ISocialNetwork[];
}

const SocialIcons: FC<Props> = ({ template, items }) => {
  const listClassName = () => {
    if (template === TemplatesList.MODERN) {
      return classes.modernWrapper;
    }
    return classes.wrapper;
  };

  const iconsMapper = (item: ISocialNetwork, index: number) => {
    return (
      <li key={index}>
        <a href={item.url}>
          <SocialIcon icon={item.name} />
        </a>
      </li>
    );
  };

  return <>{!!items?.length && <ul className={listClassName()}>{items.map(iconsMapper).filter(item => item !== null)}</ul>}</>;
};

export default SocialIcons;
